// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let afflictionTestResultEnum = {
    'Inconclusive': 0,
    'Failed': 1,
    'Passed': 2
};

export default afflictionTestResultEnum;
